import { createFileRoute, redirect, useLocation } from '@tanstack/react-router'
import { orderListSearchSchema, ServiceOrderEditForm } from '@/features/order/index.ts'

export const Route = createFileRoute('/_authenticated/orders/service/$orderId/edit')({
  beforeLoad: ({ params }) => {
    const orderId = Number(params.orderId)

    if (!Number.isInteger(orderId) || orderId <= 0) {
      throw redirect({ to: '/orders/service', replace: true, search: { current: 1, pageSize: 20 } })
    }
  },
  component: EditServiceOrderPage,
  head: () => ({ meta: [{ title: '服务订单详情 · Super Mega' }] })
})

function EditServiceOrderPage() {
  const { currentSession } = Route.useRouteContext()
  const { orderId } = Route.useParams()
  const savedReturnSearch = useLocation({ select: (location) => location.state.serviceOrderListReturnSearch })
  const returnSearch = orderListSearchSchema.parse(savedReturnSearch ?? {})
  return (
    <ServiceOrderEditForm
      canManage={
        currentSession.isSuperAdmin ||
        currentSession.permissions.some(
          (permission) => permission.startsWith('order.service.') && !permission.endsWith('.read')
        )
      }
      canReadBills={currentSession.isSuperAdmin || currentSession.permissions.includes('bill.read')}
      canSubmit={currentSession.isSuperAdmin || currentSession.permissions.includes('order.service.create')}
      orderId={Number(orderId)}
      returnSearch={returnSearch}
    />
  )
}
